import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const SecureReportViewer = () => {
  const { encoded } = useParams();
  const [reportUrl, setReportUrl] = useState('');

  useEffect(() => {
    try {
      // Decode the Base64 string
      const decoded = atob(encoded);
      const fullUrl = `${window.location.origin}/${decoded}?hideBack=true`;
      setReportUrl(fullUrl);
      
      // Prevent back navigation
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', () => {
        window.history.pushState(null, '', window.location.href);
      });
      
      // Hide URL bar on mobile by scrolling
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 100);
      
    } catch (error) {
      console.error('Invalid encoded URL:', error);
      window.location.href = '/';
    }
  }, [encoded]);

  if (!reportUrl) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '48px', 
            marginBottom: '20px',
            animation: 'spin 1s linear infinite'
          }}>
            🔓
          </div>
          <h2>Loading Secure Report...</h2>
          <p style={{ color: '#666', marginTop: '10px' }}>
            Please wait
          </p>
        </div>
        
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      backgroundColor: '#fff'
    }}>
      <style>{`
        body {
          margin: 0;
          padding: 0;
          overflow: hidden;
        }
        
        /* Hide URL bar on mobile */
        @media screen and (max-width: 768px) {
          body {
            position: fixed;
            width: 100%;
            height: 100%;
          }
        }
      `}</style>
      
      <iframe 
        src={reportUrl}
        title="Medical Report"
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0
        }}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
      />
    </div>
  );
};

export default SecureReportViewer;
